import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'main'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/agree',
    name: 'Agree',
    component: () => import('../views/join/Agree.vue')
  },
  {
    path: '/join',
    name: 'Join',
    component: () => import('../views/join/Join.vue')
  },
  {
    path: '/joinResult',
    name: 'JoinResult',
    component: () => import('../views/join/JoinResult.vue'),
    props: true,
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('../views/board/Main.vue')
  },
  {
    path: '/list/:boardType',
    name: 'List',
    component: () => import('../views/board/List.vue'),
    props: true,
  },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
